import { TvStatus } from '@tmdb-graphql-api/schema/types';
import { formatAirDates } from '#helpers/formatAirDates.ts';
import { formatDate, tt } from '#i18n/index.ts';

export const formatTvAirDates = (
  firstAirDate: string,
  lastAirDate: string | null | undefined,
  nextEpisodeToAirDate: string | null | undefined,
  status: TvStatus,
): string => {
  const firstAirDateObj = new Date(firstAirDate);
  const lastAirDateObj = lastAirDate ? new Date(lastAirDate) : undefined;
  const nextEpisodeToAirDateObj = nextEpisodeToAirDate ? new Date(nextEpisodeToAirDate) : undefined;

  switch (status) {
    case TvStatus.Canceled: {
      return lastAirDateObj
        ? `${tt('watchlist.airDates.CANCELED.withDate')} ${formatDate(lastAirDateObj, 'LLL yyyy')}`
        : tt('watchlist.airDates.CANCELED.fallback');
    }

    case TvStatus.Ended: {
      return String(formatAirDates(firstAirDate, lastAirDate, status));
    }

    case TvStatus.Planned: {
      const dateObj = nextEpisodeToAirDateObj ?? firstAirDateObj;
      return `${tt('watchlist.airDates.PLANNED')} ${formatDate(dateObj, 'yyyy')}`;
    }

    case TvStatus.InProduction: {
      return `${tt('watchlist.airDates.IN_PRODUCTION')} ${formatDate(firstAirDateObj, 'LLL yyyy')}`;
    }

    case TvStatus.Pilot: {
      return nextEpisodeToAirDateObj
        ? `${tt('watchlist.airDates.PILOT.withDate')} ${formatDate(firstAirDateObj, 'LLL M, yyyy')}`
        : tt('watchlist.airDates.PILOT.fallback');
    }

    case TvStatus.ReturningSeries: {
      return nextEpisodeToAirDateObj
        ? `${tt('watchlist.airDates.RETURNING_SERIES.withDate')} ${formatDate(firstAirDateObj, 'LLL M, yyyy')}`
        : tt('watchlist.airDates.RETURNING_SERIES.fallback');
    }
  }
};
